import { useUserStore } from '../app/user/user-store';

const HasRoles = {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$hasRole', { 
      // eslint-disable-next-line object-shorthand
      value: function (value) { // value is the role name or array
        // split on ,
        const roles = value.split(',');
        const store = useUserStore();
        if (!roles.includes(store?.getters?.user?.roleName)) return false;
        return true;
      } 
    });
  }
}
export default HasRoles;
